export const getMerchantId = ({ root }) => root.user.info.data.merchantId;
export const getUUID = ({ root }) => root.user.info.data.uuid;
export const getStores = ({ root }) => root.user.info.data.stores;
